import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { useForm } from "react-hook-form";
// import { useGoogleAuth } from "./useGoogleAuth"; // Import the custom hook
import { Stars } from "lucide-react";
import useToastStore from "@/shared/zustand/toastStore";
import { loginWithGoogle } from "@/core/api/api";
function LoginComponent() {
    const { register, handleSubmit,
    // formState: { errors, isValid },
     } = useForm({ mode: "onChange" });
    const { showToast } = useToastStore();
    // const googleLogin = useGoogleAuth({ scope: "https://mail.google.com/" }); // Hook to handle Google login
    const onSubmit = (data) => {
        console.log("Form submitted:", data);
    };
    const handleLoginWithGoogle = async () => {
        try {
            const { responseData, error } = await loginWithGoogle("https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email");
            // console.log("addScopes response:", response.data.authorizationUrl);
            if (responseData?.authorizationUrl) {
                // console.log("addScopes response:", response);
                window.location.href = responseData?.authorizationUrl;
            }
            else {
                console.error("Authorization URL not found in response", error);
                showToast("error", "Error", "Authorization URL not found in response");
            }
        }
        catch (error) {
            console.error("Error during Google login:", error);
            showToast("error", "Error", "An error occurred during Google login, check console for more details.");
        }
    };
    // const handleLoginWithGithub = async () => {
    //   showToast("info", "Info", "Fature coming soon");
    // };
    const handleLoginWithAzure = async () => {
        showToast("info", "Info", "Fature coming soon");
        console.info("Feature coming soon");
    };
    return (_jsxs("div", { className: "w-full h-full grid grid-cols-1 md:grid-cols-2 bg-white text-white", children: [_jsx("div", { className: " h-full flex flex-col justify-center items-center p-6 bg-gradient-to-r from-[#2546F0] to-[#5928ED]", children: _jsxs("div", { className: "w-[400px]", children: [_jsx(Stars, { size: 75, fill: "white" }), _jsx("h1", { className: "text-4xl font-bold mt-5", children: "Welcome to creative workspace!" }), _jsx("p", { className: "text-base mt-1", children: "Streamline your creative projects with ease." })] }) }), _jsx("div", { className: "flex justify-center items-center h-full", children: _jsx(Card, { className: "w-[400px] m-auto p-6 shadow-none rounded-[8px] font-content", title: _jsx("h3", { className: "text-lg text-[#101828] font-semibold", children: "Sign in to your account" }), children: _jsx("form", { onSubmit: handleSubmit(onSubmit), className: "w-full mx-auto space-y-6 relative", children: _jsxs(Button, { type: "button", className: "w-full rounded-[8px] px-3 py-2 p-button-outlined flex justify-center items-center gap-x-3", 
                            // onClick={googleLogin}
                            onClick: handleLoginWithGoogle, children: [_jsx("span", { className: "pi pi-google" }), _jsx("span", { children: "Sign in with Google" })] }) }) }) })] }));
}
export default LoginComponent;
